import { createGlobalStyle } from "styled-components";
/**
 * Modified version of Eric Meyer's CSS GlobalReset. Additions are an opinionated box
 * model (border-box), and more elaborate font-smoothing.
 *
 * @see http://meyerweb.com/eric/tools/css/reset/
 */
export const GlobalReset = createGlobalStyle `
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video,
  hr {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  html {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -khtml-font-smoothing: antialiased;
    -apple-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`;
//# sourceMappingURL=data:application/json;base64,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